export default "__VITE_ASSET__0v3r$wM6__"